import React, { useState } from 'react'
import { StyleSheet } from 'react-native'
import { DNABox, DNAButton, DNAButtonProps, DNAText } from '@alucio/lux-ui'
import DNAPopover from 'src/components/DNA/Popover/DNAPopover'
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'
import { useAppSettings, DeviceMode } from 'src/state/context/AppSettings'

const styles = StyleSheet.create({
  offlineContent: {
    backgroundColor: colors['color-text-white'],
    borderRadius: 8,
    padding: 24,
    borderColor: colors['color-black'],
    shadowColor: colors['color-black'],
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.16,
    shadowRadius: 11.22,
  },
  title: {
    paddingBottom: 16,
  },
})

type DeviceModeButtonProps = Record<DeviceMode, DNAButtonProps>
const deviceModeButtonProps:DeviceModeButtonProps = {
  desktop: {
    size: 'lg',
  },
  tablet: {
    appearance: 'ghost',
    rounded: true,
    size: 'xl',
    colorMode: 'dark',
  },
}

const NetworkOfflineButton: React.FC = () => {
  const [contentVisible, setContentVisible] = useState<boolean>(false);
  const toggleContent = () => setContentVisible(p => !p)
  const { deviceMode, isOnline } = useAppSettings()
  const currentDeviceModeButtonProps = deviceModeButtonProps[deviceMode]

  if (isOnline) return null;

  return (
    <DNAPopover
      lazyMount
      placement="bottom-end"
      interactive={true}
      visible={contentVisible}
      onBackdropPress={toggleContent}
      type="menu"
    >
      <DNAPopover.Anchor style={{ height: '100%' }}>
        <DNAButton
          {...currentDeviceModeButtonProps}
          status="warning"
          iconLeft="wifi-slash"
          onPress={toggleContent}
          appearance={'ghost'}
          size={deviceMode === 'desktop' ? 'md' : 'xl'}
          rounded={false}
          colorMode={'light'}
        />
      </DNAPopover.Anchor>
      <DNAPopover.Content offset={10}>
        <NetworkOfflineContent />
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export const NetworkOfflineContent: React.FC = () => {
  return (
    <DNABox appearance="row" fill>
      <DNABox appearance="col" style={styles.offlineContent}>
        <DNAText b1 bold style={styles.title}>No internet connection</DNAText>
        <DNAText b1>Some features will be unavailable in offline mode.</DNAText>
      </DNABox>
    </DNABox>
  )
}

export default NetworkOfflineButton
